// a2-42 — what a failed passkey ceremony says on the sign-in screen.
//
// `signInWithPasskey` printed the library's own message verbatim, so a
// failed challenge read "Unexpected end of JSON input" and a cancelled Face
// ID prompt read "The operation either timed out or was not allowed", while
// `registerPasskey` in the same file already said "Cancelled." for the
// second. One rule for both now, here, with no imports so the root suite
// can test it.
//
// The browser reports a dismissed prompt as `NotAllowedError` (or
// `AbortError` when the ceremony is aborted); auth-js wraps it in a
// `WebAuthnError` whose `name` is the cause's and, for an abort, whose
// `code` is `ERROR_CEREMONY_ABORTED`.

export interface ErrorLike { name?: string; code?: string; message?: string }

export const CANCELLED = 'Cancelled.'

/** Doug dismissed the prompt (or it timed out): not a failure to explain. */
export function passkeyCancelled(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false
  const e = err as ErrorLike
  return e.name === 'NotAllowedError' || e.name === 'AbortError' || e.code === 'ERROR_CEREMONY_ABORTED'
}

/** The sign-in screen's line for a passkey attempt, or `null` when it
 *  worked. Anything but a cancel is one plain sentence pointing at the way
 *  that still works; the library's message is for the console, not Doug. */
export function passkeySignInError(err: unknown): string | null {
  if (!err) return null
  if (passkeyCancelled(err)) return CANCELLED
  return "Couldn't sign in with a passkey. Use the password instead."
}
